{
  "dropzoneLabel": "Místo pro přetažení",
  "selectPlaceholder": "Vyberte položku",
  "tableResizer": "Změna velikosti"
}
